module.exports = __webpack_public_path__ + "assets/dropdown_menu.png";